import { mergePreservingGetters } from './reactive'

export function resolveValueOrMethod(scope, key) {

    const result = key.split('.')
        .reduce((object, property) => object && object[ property ] !== undefined ? object[ property ] : undefined, scope)

    if (typeof result === 'function') {
        return evaluateExpression(`${ key }()`, scope)
    }

    return result

}

export function evaluateInScope(expression, scope = {}, extra = {}) {

    if (typeof expression === 'function') {
        return evaluateExpression(`${ expression }`, scope)
    }

    expression = expression?.trim() || ''

    if (!expression.length) { return null }

    if (expression === 'true') { return true }

    if (expression === 'false') { return false }

    // Simple expressions like "property"
    if (/^[\w.]+$/.test(expression)) {
        return resolveValueOrMethod(scope, expression)
    }

    return evaluateExpression(expression, scope, extra)

}

export function assignInScope(expression, scope, value) {

    try {

        const evaluator = new Function('scope', 'value', `with (scope) { ${ expression } = value }`)

        evaluator(scope, value)

    } catch (error) {
        console.error(`Error evaluating expression for 'assignInScope': ${ expression }`, error, ...Object.keys(scope))
    }

}

function evaluateExpression(expression, scope = {}, extra = {}) {

    try {

        const mergedScope = mergePreservingGetters(scope, extra)
        const evaluator = new Function('mergedScope', `with(mergedScope) { return ${ expression } }`)
        const result = evaluator(mergedScope)

        return result

    } catch (error) {

        console.error(`Error evaluating expression for 'evaluateInScope': ${ expression }`, error, ...Object.keys(scope))

        return null

    }

}
